/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const invoicePrintSettings = sqliteTable('invoice_print_settings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  template_id: text('template_id'),
  logo_source: text('logo_source'),
  clinic_name: text('clinic_name'),
  clinic_address: text('clinic_address'),
  clinic_phone: text('clinic_phone'),
  clinic_email: text('clinic_email'),
  clinic_website: text('clinic_website'),
  tax_id: text('tax_id'),
  footer_text: text('footer_text'),
  show_patient_demographics: integer('show_patient_demographics'),
  show_patient_number: integer('show_patient_number'),
  show_invoice_number: integer('show_invoice_number'),
  show_invoice_date: integer('show_invoice_date'),
  show_visit_date: integer('show_visit_date'),
  show_provider: integer('show_provider'),
  show_item_quantity: integer('show_item_quantity'),
  show_item_unit_price: integer('show_item_unit_price'),
  show_item_discount: integer('show_item_discount'),
  show_item_tax: integer('show_item_tax'),
  show_item_amount: integer('show_item_amount'),
  show_subtotal: integer('show_subtotal'),
  show_discount_total: integer('show_discount_total'),
  show_tax_total: integer('show_tax_total'),
  show_payments: integer('show_payments'),
  show_balance_due: integer('show_balance_due'),
  show_footer_notes: integer('show_footer_notes'),
  show_signature_block: integer('show_signature_block'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
